module.exports = __webpack_public_path__ + "img/top_reight.887f410e.svg";